import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const ProductUnit = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['product-unit', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('product_unit_information')}
    tableConfig={{
      key: "id",
      apiPath: "produnit/list",
      allowDelete: {
        visible: true,
        key: "unit_id",
        apiPath: "produnit/delete",
        paramType: "param"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'unit_code',
          caption: t('product_code'),
          allowFiltering: true
        },
        {
          dataField: 'unit_name',
          caption: t('product_unit'),
          allowFiltering: true
        },
        {
          dataField: 'description',
          caption: t('description'),
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edited_by'),
        }
      ],
      exportExcel: {
        fileName: t('product_unit_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('product_code'), value: 'unit_code' },
          { label: t('product_unit'), value: 'unit_name' },
          { label: t('description'), value: 'description' },
          { label: t('status'), value: 'status_name' },
          { label: t('edited_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      unit_code: "",
      unit_name: "",
      description: "",
      status: "Y"
    }}
    modalConfig={{
      visible: true,
      title: t('product_unit_information'),
      required: ["unit_code", "unit_name"],
      fieldTypeNumber: [],
      paramName: "unit_id",
      apiPath: {
        "get": '',
        "post": 'produnit/add',
        "put": 'produnit/update'
      },
      elements: [
        {
          fieldName: "unit_code",
          label: t('product_unit_code'),
          placeholder: t('product_unit_code'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "unit_name",
          label: t('product_unit_name'),
          placeholder: t('product_unit_name'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "description",
          label: t('description'),
          placeholder: t('description'),
          inputType: "text",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default ProductUnit